export const GET_REGISTRATION_PAYMENT_LIST_SUCCESS = "GET_REGISTRATION_PAYMENT_LIST_SUCCESS";
export const UPDATE_GENERATED_PAYMENT_REF = "UPDATE_GENERATED_PAYMENT_REF";
export const UPDATE_FINANCE_OPERATION_DATA = "UPDATE_FINANCE_OPERATION_DATA";